import React from 'react';

import Link from '../../elements/Link';
import content from './content';
import './style.scss';

function Footer(props) {
  const { locale = '' } = props;
  const footerItems =
    locale === '' ? content['footerItems'] : content[locale.replace('-', '') + '_footerItems'];

  const { footerLogo, tos, columns } = footerItems;

  return (
    <div className="container footer-container">
      <div className="row justify-content-between g-0">
        <div className="col-xl-3 me-auto" id="leftPanel">
          <div className="row footer-row g-0">
            <div>
              <img loading='lazy' src={footerLogo.src} alt="logo" />
            </div>
          </div>

          <div className="row g-0">
            <p className="terms mb-0">
              Checkbook Payment Holdings, Inc.; NMLS ID #<a href="https://statemortgageregistry.com/View/Company/CompanyInfo.aspx?CompanyId=2535348" target="_blank" referrerPolicy="no-referrer">2535348</a>
            </p>

            <p className="terms">{tos}</p>
          </div>
        </div>

        <div className="col-xl-8 offset-xl-1" id="rightPanel">
          <div className="row g-0 justify-content-between">
            {columns.map((col, i) => (
              <ul className="col-md-auto" key={i}>
                {col.rows.map((row, j) => (
                  <div key={j}>
                    <li
                      className={
                        row.name == 'Developer' ||
                        row.name == 'Connect' ||
                        row.name == 'Resources'
                          ? 'col-name spacing'
                          : 'col-name'
                      }
                    >
                      {row.name}
                    </li>
                    {row.items.map((link, k) => (
                      <li key={k}>
                        {link.src ? (
                          <a href={link.src}>{link.name}</a>
                        ) : (
                          link.name
                        )}
                      </li>
                    ))}
                  </div>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
